export const DEFAULT_GRAVITY_Y = 300;